"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bootstrap_1 = require("bootstrap");
const form_1 = require("./form");
const swiper_1 = require("swiper"); /* used by new styles */
const rellax_1 = __importDefault(require("rellax"));
const player_1 = __importDefault(require("@vimeo/player"));
require("./map");
const dots_1 = require("./dots");
/* class to stop bootrap default scroll logic */
// console.log('foo 48');
// Helper function to add/remove no-scroll class
const html = document.documentElement;
document.querySelectorAll('.modal').forEach((modalEl) => {
    // When modal is shown
    modalEl.addEventListener('show.bs.modal', (event) => {
        html.classList.add('no-scroll');
    });
    // When modal is hidden
    modalEl.addEventListener('hide.bs.modal', (event) => {
        html.classList.remove('no-scroll');
    });
});
let carousel = bootstrap_1.Carousel;
//console.log('init saltus')
let dots = new dots_1.Dots({
    length: 5,
    elementSelector: '.portal-dots'
});
const quoteCarousels = document.querySelectorAll('.quote-carousel .carousel');
Array.from(quoteCarousels).forEach(el => {
    let tallest = 240;
    const quoteSlides = el.querySelectorAll('.carousel-item .text-dust');
    // console.log('quoteSlides',quoteSlides);
    Array.from(quoteSlides).forEach(slide => {
        // console.log(slide,'slide');
        const slideH = slide.clientHeight;
        //console.log(slideH,'slideH');
        if (slideH > tallest) {
            tallest = slideH;
        }
    });
    Array.from(quoteSlides).forEach(slide => {
        const slideEl = slide;
        slideEl.parentElement.parentElement.style.height = tallest + 'px';
        // console.log(slide,'slide');
    });
});
const pullQuoteCarousels = document.querySelectorAll('.pull-quote .carousel');
if (window.innerWidth > 768) {
    Array.from(pullQuoteCarousels).forEach(el => {
        let tallest = 190;
        if (window.innerWidth < 1155) {
            tallest = 275;
        }
        const quoteSlides = el.querySelectorAll('.carousel-item .pull-quote-text');
        //console.log('quoteSlides',quoteSlides);
        Array.from(quoteSlides).forEach(slide => {
            //console.log(slide,'slide');
            const slideH = slide.clientHeight;
            // console.log(slideH,'slideH');
            if (slideH > tallest) {
                tallest = slideH;
            }
        });
        Array.from(quoteSlides).forEach(slide => {
            const slideEl = slide;
            slideEl.parentElement.parentElement.style.height = tallest + 'px';
            // console.log(slide,'slide');
        });
    });
}
// this shows notification modal on home page
if (document.getElementById('notificationModal')) {
    bootstrap_1.Modal.getOrCreateInstance(document.getElementById('notificationModal')).show();
}
if (document.getElementById('hfaNotificationModal')) {
    bootstrap_1.Modal.getOrCreateInstance(document.getElementById('hfaNotificationModal')).show();
}
if (document.getElementById('bjNotificationModal')) {
    bootstrap_1.Modal.getOrCreateInstance(document.getElementById('bjNotificationModal')).show();
}
var throttle = require('lodash.throttle');
ScrollReveal().reveal('.reveal', {
    interval: 750,
    delay: 500,
    viewFactor: 0.25,
    reset: false,
    afterReveal: onReveal1,
});
ScrollReveal().reveal('.reveal-line', {
    interval: 750,
    viewFactor: 0.25,
    reset: false,
    afterReveal: onReveal1,
});
ScrollReveal().reveal('.reveal-portal', {
    interval: 750,
    delay: 500,
    viewFactor: 0.25,
    //reset: true,
    afterReveal: onReveal,
    afterReset: onReset
});
ScrollReveal().reveal('.reveal-map', {
    interval: 0,
    distance: '0px',
    delay: 500,
    viewFactor: 0.5,
    reset: false,
    afterReveal: onReveal1,
    // afterReset: onReset1
});
function onReveal1(el) {
    //console.log(el,'el reveal')
    el.classList.add('is-visible');
}
function onReset1(el) {
    //console.log(el,'el reveal')
    el.classList.remove('is-visible');
}
function onReveal(el) {
    //console.log(el,'el reveal')
    el.classList.add('is-visible');
    setPlayers(el, 'play');
}
function onReset(el) {
    // console.log(el,'el reset')
    el.classList.remove('is-visible');
    setPlayers(el, 'pause');
}
function setPlayers(el, action) {
    // console.log('set players el',el)
    const parent = el.closest('.portal-strip');
    let player1;
    let player2;
    let player3;
    //set players
    if (parent) {
        switch (parent.id) {
            case 'family-wealth':
                player1 = players[0];
                break;
            case 'wealth-growth':
                player1 = players[1];
                player2 = players[2];
                break;
            case 'important-documents':
                player1 = players[3];
                player2 = players[4];
                break;
            case 'investments':
                player1 = players[5];
                player2 = players[6];
                player3 = players[7];
                break;
            default:
                //transactions
                player1 = players[8];
                player2 = players[9];
                break;
        }
    }
    if (player1) {
        const player1Playing = player1.currentTime > 0 && !player1.paused && !player1.ended
            && player1.readyState > player1.HAVE_CURRENT_DATA;
        if (action == 'play') {
            player1.play();
        }
        else {
            player1.pause();
            player1.setCurrentTime(0);
        }
    }
    if (player2) {
        const player2Playing = player2.currentTime > 0 && !player2.paused && !player2.ended
            && player2.readyState > player2.HAVE_CURRENT_DATA;
        if (action == 'play') {
            player2.play();
        }
        else {
            player2.pause();
            player2.setCurrentTime(0);
        }
    }
    if (player3) {
        const player3Playing = player3.currentTime > 0 && !player3.paused && !player3.ended
            && player3.readyState > player3.HAVE_CURRENT_DATA;
        if (action == 'play') {
            player3.play();
        }
        else {
            player3.pause();
            player3.setCurrentTime(0);
        }
    }
}
ScrollReveal().reveal('.reveal-500', {
    interval: 500,
    delay: 500,
    reset: false,
    viewFactor: 0.25
});
ScrollReveal().reveal('.reveal-mob', {
    interval: 500,
    delay: 500,
    reset: false,
    viewFactor: 0.25
});
//sticky class
function apply_stickies() {
    var _$stickies = [].slice.call(document.querySelectorAll('.wi-landing-sticky'));
    _$stickies.forEach(function (_$sticky) {
        if (CSS.supports && CSS.supports('position', 'sticky')) {
            apply_sticky_class(_$sticky);
        }
    });
}
function apply_sticky_class(_$sticky) {
    var currentOffset = _$sticky.getBoundingClientRect().top;
    var stickyOffset = parseInt(getComputedStyle(_$sticky).top.replace('px', ''));
    var isStuck = currentOffset <= stickyOffset + 1;
    _$sticky.classList.toggle('js-is-sticky', isStuck);
}
//accordion hash for wi landing experts
if (location.hash !== null && location.hash !== "") {
    const accordionItems = document.querySelectorAll(".wi-landing-experts " + location.hash + ".collapse");
    if (accordionItems.length > 0) {
        const accordionHeaders = document.querySelectorAll(".wi-landing-experts .accordion-header .rounded-pill");
        const header0 = accordionHeaders[0];
        const accordionExperts = document.querySelector(".wi-landing-experts");
        if (header0.dataset.bsTarget != location.hash) {
            accordionItems.forEach(function (value) {
                const accordionItem = bootstrap_1.Collapse.getOrCreateInstance(value);
                accordionItem.show();
                window.scrollTo({
                    top: accordionExperts.offsetTop
                });
            });
        }
        else {
            window.scrollTo({
                top: accordionExperts.offsetTop
            });
        }
    }
}
//create array of page players
const portalVideos = document.querySelectorAll('.portal-strip iframe');
const players = new Array();
//console.log(players,'players')
if (portalVideos.length > 0) {
    Array.from(portalVideos).forEach((el, index) => {
        const element = el;
        //console.log(el.id, 'iframe id')
        const player = new player_1.default(element);
        players.push(player);
    });
}
// Define our viewportWidth variable
let viewportWidth;
// Set/update the viewportWidth value
const setViewportWidth = function () {
    viewportWidth = window.innerWidth || document.documentElement.clientWidth;
};
const rellaxEl = document.querySelectorAll('.rellax');
// Log the viewport width into the console
const setRellax = function () {
    if (viewportWidth > 768 && rellaxEl.length > 0) {
        //console.log('Wide viewport');
        const rellax = new rellax_1.default('.rellax', {
            center: true
            // wrapper:'.portal-strip'
        });
    }
};
// Set our initial width and log it
setViewportWidth();
setRellax();
// On resize events, recalculate and log
window.addEventListener('resize', function () {
    setViewportWidth();
    setRellax();
}, false);
// Portal - highlighted text on scroll
const siblings = (elem) => {
    // create an empty array
    let siblings = [];
    // if no parent, return empty list
    if (!elem.parentNode) {
        return siblings;
    }
    // first child of the parent node
    let sibling = elem.parentNode.firstElementChild;
    // loop through next siblings until `null`
    do {
        // push sibling to array
        if (sibling != elem) {
            siblings.push(sibling);
        }
    } while (sibling = sibling.nextElementSibling);
    return siblings;
};
//percentage seen in viewport
const percentageSeen = (elem) => {
    // Get the relevant measurements and positions
    const viewportHeight = window.innerHeight;
    const scrollTop = window.scrollY;
    const elementOffsetTop = elem.offsetTop;
    const elementHeight = elem.offsetHeight;
    // Calculate percentage of the element that's been seen
    const distance = (scrollTop + viewportHeight) - elementOffsetTop;
    const percentage = Math.round(distance / ((viewportHeight + elementHeight) / 100));
    // Restrict the range to between 0 and 100
    return Math.min(100, Math.max(0, percentage));
};
//scroll direction setup
let lastScrollTop = 0;
let scrollDirection;
window.addEventListener('scroll', throttle(() => {
    apply_stickies();
    // console.log('apply_stickies')
    // portal highlight text
    let gridTop;
    const windowHeight = window.innerHeight, gridBottom = windowHeight, highlights = document.querySelectorAll('.portal-highlight-text li');
    if (viewportWidth < 1070 && viewportWidth > 767) {
        gridTop = windowHeight * .5;
    }
    if (viewportWidth < 768) {
        gridTop = windowHeight * .5;
    }
    else {
        gridTop = windowHeight * .7;
    }
    //console.log(highlights,'highlights')
    for (var i = 0; i < highlights.length; i++) {
        //console.log(highlights[i]);
        const item = highlights[i];
        const thisTop = window.scrollY - item.offsetTop;
        // console.log(thisTop,'this top')
        // console.log(gridTop,'grid top')
        // console.log(gridBottom,'grid bottom')
        if (thisTop > gridTop && thisTop < gridBottom) {
            const nodes = siblings(item);
            nodes.forEach(function (value) {
                value.classList.remove("opacity-1");
            });
            item.classList.add('opacity-1');
        }
        else {
            item.classList.remove('opacity-1');
        }
    }
}));
// Bootstrap Scrollspy
const navScroll = document.getElementsByClassName('navbar-scroll');
if (navScroll.length > 0) {
    let scrollSpy = new bootstrap_1.ScrollSpy(document.body, {
        target: '.navbar-scroll'
    });
    // console.log(scrollSpy);
    // console.log('scrollspy!')
}
let menuTriggers = document.getElementsByClassName('modal-menu');
let activeModal;
Array.from(menuTriggers).forEach(el => {
    let element = el;
    el.addEventListener('click', function (event) {
        event.preventDefault();
        if (element.classList.contains('navbar-contact') || element.classList.contains('header-contact')) {
            document.body.classList.remove('modal-menu-open');
            if (activeModal)
                activeModal.hide();
            return;
        }
        // hide currently active modal
        if (activeModal)
            activeModal.hide();
        // trigger x transition
        document.body.classList.add('modal-menu-open');
        // add modal active state to the nav
        Array.from(document.getElementsByClassName('modal-active')).forEach(element => {
            element.classList.remove('modal-active');
        });
        //console.log('foo3')
        // remove active state from sibling elements
        Array.from(document.getElementsByClassName('modal-menu')).forEach(element => {
            element.classList.remove('active');
        });
        element.classList.add('modal-active');
        if (element.dataset.bsTarget) {
            let modal;
            let menuAreas;
            menuAreas = document.querySelector('#areas');
            modal = bootstrap_1.Modal.getOrCreateInstance(document.querySelector('#' + element.dataset.bsTarget));
            modal.show();
            activeModal = modal;
            // show back arrow on mobile if a submenu, and add the title
            const mobileHeaders = document.querySelectorAll('#mobile-header');
            const mobileTitles = document.querySelectorAll('#mobile-header-title');
            if (element.dataset.bsTarget != 'mobile-nav') {
                mobileHeaders.forEach(el => {
                    el.classList.add('active');
                });
                mobileTitles.forEach(el => {
                    el.textContent = element.textContent;
                });
            }
            else {
                mobileHeaders.forEach(el => {
                    el.classList.remove('active');
                });
                mobileTitles.forEach(el => {
                    el.textContent = '';
                });
                areaSelect(menuAreas);
            }
        }
    });
});
// close the modal from the x in the menu
Array.from(document.getElementsByClassName('modal-close')).forEach(element => {
    element.addEventListener('click', () => {
        // setTimeout(()=>{
        document.body.classList.remove('modal-menu-open');
        //}, 500)
        if (activeModal)
            activeModal.hide();
    });
});
Array.from(document.getElementsByClassName('modal-nav')).forEach(element => {
    element.addEventListener('hidden.bs.modal', function (event) {
        document.body.classList.remove('modal-menu-open');
    });
});
//prevent the contact accordion from being fully collapsed
var collapseHeaders = document.querySelectorAll('.accordion-header');
var collapseElementList = [].slice.call(collapseHeaders);
if (collapseElementList) {
    collapseElementList.map(function (collapseEl, index) {
        if (collapseEl.dataset.bsTarget) {
            let collapse = bootstrap_1.Collapse.getOrCreateInstance(document.getElementById(collapseEl.dataset.bsTarget.slice(1)), { toggle: false });
            let current;
            let next;
            if (index == 0 || index == 2) {
                collapse.show();
                current = index;
                next = index + 1;
            }
            else {
                collapse.hide();
                current = index - 1;
                next = index;
            }
            // console.log(index, 'index 2')
            collapseEl.addEventListener('click', (el) => {
                const parent = el.target.closest(".accordion-header");
                if (parent.classList.contains('active')) {
                    parent.classList.remove('active');
                    if (index == 0 || index == 2) {
                        collapseElementList[next].classList.add('active');
                        bootstrap_1.Collapse.getInstance(document.getElementById(collapseElementList[next].dataset.bsTarget.slice(1))).show();
                        bootstrap_1.Collapse.getInstance(document.getElementById(collapseElementList[current].dataset.bsTarget.slice(1))).hide();
                    }
                    else {
                        collapseElementList[current].classList.add('active');
                        bootstrap_1.Collapse.getInstance(document.getElementById(collapseElementList[current].dataset.bsTarget.slice(1))).show();
                        bootstrap_1.Collapse.getInstance(document.getElementById(collapseElementList[next].dataset.bsTarget.slice(1))).hide();
                    }
                }
                else {
                    parent.classList.add('active');
                    if (index == 0 || index == 2) {
                        collapseElementList[next].classList.remove('active');
                        bootstrap_1.Collapse.getInstance(document.getElementById(collapseElementList[current].dataset.bsTarget.slice(1))).show();
                        bootstrap_1.Collapse.getInstance(document.getElementById(collapseElementList[next].dataset.bsTarget.slice(1))).hide();
                    }
                    else {
                        collapseElementList[current].classList.remove('active');
                        bootstrap_1.Collapse.getInstance(document.getElementById(collapseElementList[next].dataset.bsTarget.slice(1))).show();
                        bootstrap_1.Collapse.getInstance(document.getElementById(collapseElementList[current].dataset.bsTarget.slice(1))).hide();
                    }
                }
            });
        }
    });
}
let videoCTA = document.getElementById('video-cta');
let fpCTA = document.getElementById('fp-cta');
let blogVideo = document.getElementById('blog-video-show');
let fpVideo = document.getElementById('fp-video-show');
let fpVideo2 = document.getElementById('fp-video2-show');
let toggleForm = document.getElementById('form-toggle');
let fpForm = document.getElementById('fp-form-toggle');
if (toggleForm) {
    toggleForm.addEventListener('click', () => {
        videoCTA.classList.toggle('blog-form');
        blogVideo.classList.toggle('d-none');
        fpVideo2.classList.toggle('d-none');
    });
}
if (fpForm) {
    fpForm.addEventListener('click', () => {
        fpCTA.classList.toggle('blog-form');
        fpVideo.classList.toggle('d-none');
    });
}
// Homepage - I THINK THIS CAN BE REMOVED
let homepageCardToggle = document.getElementsByClassName('homepage-card-toggle');
Array.from(homepageCardToggle).forEach(el => {
    let element = el;
    el.addEventListener('click', function (event) {
        event.preventDefault();
        let target = document.getElementById('homepage-' + element.dataset.target);
        // closed
        if (!target.classList.contains('active')) {
            // hide other currently active card(s)
            hideActiveHomepageCards();
            target === null || target === void 0 ? void 0 : target.classList.add('active');
            let list = document.getElementById('homepage-list-' + element.dataset.target);
            // hide the statement or logo depending on which item is open
            if (element.dataset.target == '1' || element.dataset.target == '2') {
                document.getElementById('homepage-statement').classList.add('opacity-lg-0');
                document.getElementById('homepage-brand').classList.remove('opacity-lg-0');
            }
            else {
                document.getElementById('homepage-statement').classList.remove('opacity-lg-0');
                document.getElementById('homepage-brand').classList.add('opacity-lg-0');
            }
            target === null || target === void 0 ? void 0 : target.classList.add('position-lg-absolute');
            target.setAttribute('style', 'height:' + (list.offsetHeight + element.offsetHeight + 60) + 'px');
            // open
        }
        else {
            target === null || target === void 0 ? void 0 : target.classList.remove('active');
            target === null || target === void 0 ? void 0 : target.setAttribute('style', '');
            // reset opacity
            document.getElementById('homepage-statement').classList.remove('opacity-lg-0');
            document.getElementById('homepage-brand').classList.remove('opacity-lg-0');
        }
    });
});
function hideActiveHomepageCards() {
    Array.from(document.getElementsByClassName('homepage-card')).forEach(el => {
        el.classList.remove('active');
        el.setAttribute('style', '');
    });
}
Array.from(document.getElementsByClassName('homepage-card')).forEach(el => {
    el.addEventListener('transitionend', (event) => {
        if (!el.classList.contains('active') && el.id == event.target.id)
            el.classList.remove('position-lg-absolute');
    });
});
// end homepage
// add transition listener to the body, we add a modal-transition-complete class when it has opened, as we need to dynamically change the CSS transition for the close/logo
document.body.addEventListener('transitionend', (event) => {
    if (document.body.classList.contains('modal-open')) {
        document.body.classList.add('modal-transition-complete');
    }
    else {
        document.body.classList.remove('modal-transition-complete');
    }
});
// init form 
(0, form_1.formInit)('/form.php');
// Navigate to tab on page load
//console.log('url', location.hash)
if (location.hash) {
    // do we have a tab with that id
    // activate it
    var triggerEl = document.querySelector(location.hash + '-tab');
    if (triggerEl) {
        var tab = bootstrap_1.Tab.getOrCreateInstance(triggerEl);
        if (tab) {
            tab.show();
            //location.hash = '';
            const offset = document.querySelector('.tabs-content-block');
            if (!offset) {
                window.scrollTo({ top: 0 });
            }
            else {
                window.scrollTo({ top: offset.offsetTop });
            }
        }
    }
    else {
        const hashEl = document.querySelector(location.hash);
        if (hashEl) {
            window.scrollTo({
                top: document.querySelector(location.hash).offsetTop
            });
        }
    }
}
// add tab id to location.hash if it is set
Array.from(document.querySelectorAll('button[data-bs-toggle="tab"]')).forEach(tabEl => {
    tabEl.addEventListener('shown.bs.tab', (event) => {
        let target = event.target;
        if (target.id) {
            const offset = document.querySelector('.tabs-content-block');
            location.hash = target.id.replace('-tab', '');
            if (!offset) {
                window.scrollTo({ top: 0 });
            }
        }
    });
});
// open external links in a new tab
Array.from(document.body.querySelectorAll('a[href*="://"]')).forEach(a => {
    if (!a.getAttribute('href').match('localhost|saltus.co.uk|saltus.ngrok.io')) {
        a.setAttribute('target', '_blank');
    }
});
// set guide or webinar ID dynamically 
if (document.getElementById('call-to-action-modal')) {
    document.getElementById('call-to-action-modal').addEventListener('show.bs.modal', (event) => {
        // @ts-ignore
        let trigger = event.relatedTarget;
        if (trigger.dataset.type && trigger.dataset.type == 'download' && localStorage.getItem('curo')) {
            // if it is a download and there is a Curo ID in localStorage
            event.preventDefault();
        }
    });
}
//update download anchor button text dynamically if curo id exists
if (localStorage.getItem('curo')) {
    const download_anchor_link = document.getElementById('download_anchor_link');
    if (download_anchor_link) {
        download_anchor_link.className = 'et:mt-1.5 et:self-start et:inline-flex et:items-center et:text-secondary et:hover:text-secondary et:bg-midblue et:rounded-full et:no-underline et:transition-all et:duration-150 et:py-2 et:px-3.5 et:font-normal et:group et:mx-auto et:md:mx-0';
        download_anchor_link.innerHTML = 'View unlocked guide <i class="fa-regular fa-arrow-right et:text-sm et:ms-2 et:leading-none et:text-premier et:transition-transform et:duration-150 et:group-hover:translate-x-0.5"></i>';
    }
}
//get the full url and store in local storage for form submissions
let landing_url = localStorage.getItem("landing_page_url");
if (!landing_url) {
    localStorage.setItem("landing_page_url", window.location.href);
    landing_url = localStorage.getItem("landing_page_url");
}
Array.from(document.getElementsByName("landing_page_url")).forEach(element => {
    let el = element;
    el.value = landing_url;
});
//get the full url and store in session storage for form submissions
let landing_session_url = sessionStorage.getItem("landing_page_session_url");
if (!landing_session_url) {
    sessionStorage.setItem("landing_page_session_url", window.location.href);
    landing_session_url = sessionStorage.getItem("landing_page_session_url");
}
Array.from(document.getElementsByName("landing_page_session_url")).forEach(element => {
    let el = element;
    el.value = landing_session_url;
});
let stickyHeaders = document.querySelectorAll('#header-sticky');
window.addEventListener('scroll', throttle(() => {
    if (window.scrollY > 376) {
        document.body.classList.add('scrolled-text');
    }
    else {
        document.body.classList.remove('scrolled-text');
    }
    stickyHeaders.forEach(stickyHeader => {
        if (stickyHeader) {
            const heroHeight = document.querySelector('.hero-banner').clientHeight;
            const headerHeight = document.getElementById("header_lower").clientHeight;
            document.body.classList.add('header-sticky-show');
            if (window.scrollY > (heroHeight + headerHeight / 2)) {
                stickyHeader.classList.add('header-sticky-show');
                stickyHeader.classList.remove('header-sticky-hide');
            }
            else {
                stickyHeader.classList.add('header-sticky-hide');
                stickyHeader.classList.remove('header-sticky-show');
            }
        }
        stickyHeight(stickyHeader);
    });
}, 100));
// hide blog nav sticky when modal is open
Array.from(document.getElementsByClassName('modal')).forEach(element => {
    element.addEventListener('shown.bs.modal', function (event) {
        stickyHeaders.forEach(stickyHeader => {
            if (stickyHeader) {
                stickyHeader.classList.add('d-lg-none');
            }
        });
    });
});
// show blog nav sticky when modal is closed
Array.from(document.getElementsByClassName('modal')).forEach(element => {
    element.addEventListener('hidden.bs.modal', function (event) {
        stickyHeaders.forEach(stickyHeader => {
            if (stickyHeader) {
                stickyHeader.classList.remove('d-lg-none');
            }
        });
    });
});
document.querySelectorAll('.blog .h4, .blog h4, .blog h2, .blog .h2, .wealth-index-text h4, .wi-landing .wealth-index-text h3, .wealth-index-sticky h5, .video-template h4, .video-template h3, .video-template h2').forEach((el) => {
    el.insertAdjacentHTML("beforeend", "<span class='line line__short line__dark my-4'></span>");
});
function sanitizeTitle(title) {
    // Convert to lowercase
    let sanitizedTitle = title.toLowerCase();
    // Replace spaces and non-alphanumeric characters (except hyphens and underscores) with hyphens
    sanitizedTitle = sanitizedTitle.replace(/[^a-z0-9-]+/g, '-');
    // Replace multiple consecutive hyphens with a single hyphen
    sanitizedTitle = sanitizedTitle.replace(/-+/g, '-');
    // Remove leading or trailing hyphens
    sanitizedTitle = sanitizedTitle.replace(/^-+|-+$/g, '');
    return sanitizedTitle;
}
const takeawayList = document.querySelector('.key-takeaways ol');
if (takeawayList) {
    document.querySelectorAll('.blog-text-content .h4, .blog-text-content h4, .blog-text-content h2, .blog-text-content .h2, .blog-text-content h3, .blog-text-content .h3').forEach((el) => {
        //console.log('headings blog',el)
        // Create a new <li> element
        const newLi = document.createElement('li');
        newLi.classList.add('h5', 'mb-3');
        // Create a new <a> element (link)
        const link = document.createElement('a');
        // Set the href attribute for the link
        link.href = "#" + sanitizeTitle(el.textContent);
        //console.log(link,'link test 2')
        // Set the link's text content
        link.textContent = el.textContent;
        // Append the <a> inside the <li>
        newLi.appendChild(link);
        // Append the new <li> to the <ol>
        takeawayList.appendChild(newLi);
        const newAnchor = document.createElement('div');
        newAnchor.setAttribute('id', sanitizeTitle(el.textContent));
        newAnchor.classList.add('wealth-index-anchor', 'wealth-index-anchor-blog');
        el.parentElement.insertBefore(newAnchor, el);
    });
    let takeawaysHeight = 0;
    document.querySelectorAll('.takeaways li').forEach((el, index) => {
        if (index < 2) {
            takeawaysHeight += el.offsetHeight;
        }
        // console.log('index',index)
        // console.log('el',el)
    });
    const takeaways = document.querySelector('.takeaways-list');
    const takeawaysGradient = document.querySelector('.takeaways-gradient');
    const takeawaysStart = takeaways.querySelector('ul').offsetHeight;
    const takeawaysBtn = document.querySelector('.takeaways-btn');
    if (takeaways && takeaways.closest('.takeaways-more')) {
        takeaways.style.maxHeight = takeawaysHeight.toString() + 'px';
    }
    if (takeawaysBtn) {
        takeawaysBtn.addEventListener('click', (event) => {
            //console.log('click! 8')
            const evtTarget = event.target;
            const evtClosest = evtTarget.closest('.takeaways-btn');
            const evtArrow = evtClosest.querySelector('.arrow-link');
            evtArrow.classList.toggle('arrow-link-down');
            evtArrow.classList.toggle('arrow-link-down-hover');
            evtArrow.classList.toggle('arrow-link-up');
            evtArrow.textContent = evtArrow.textContent === 'Read less...' ? 'Read more...' : 'Read less...';
            takeaways.style.maxHeight = takeaways.style.maxHeight === takeawaysStart.toString() + 'px' ? takeawaysHeight.toString() + 'px' : takeawaysStart.toString() + 'px';
            takeawaysGradient.style.opacity = takeawaysGradient.style.opacity === '0' ? '1' : '0';
        });
    }
}
// Select dropdown for blog categories, mobile only
const categorySelect = document.querySelector(`[id="categorySelect"]`);
if (categorySelect) {
    categorySelect.addEventListener('change', (e) => {
        const target = e.target;
        location.href = target.value;
    });
    const option = categorySelect.querySelector(`[value="${location.href}"]`);
    if (option) {
        option.selected = true;
    }
}
const selectedTable = document.querySelectorAll('.data-table');
const dataCenterTables = document.querySelectorAll('.data-tables');
const firstDataTable = document.querySelector('.data-tables');
if (selectedTable) {
    Array.from(selectedTable).forEach(element => {
        dataTableSelect(element, dataCenterTables, firstDataTable, "data-tables");
    });
}
function dataTableSelect(select, tables, firstTable, dataTableClass) {
    firstTable.classList.remove('d-none');
    select.addEventListener('change', (e) => {
        let selectedIndex = e.target.selectedIndex;
        let currentTable = `${dataTableClass}-${selectedIndex}`;
        Array.from(tables).forEach(element => {
            if (element.classList.contains(currentTable)) {
                element.classList.remove('d-none');
            }
            else {
                element.classList.add('d-none');
            }
        });
    });
}
// TODO: Make function 
let aauSticky = document.querySelector('.header-sticky-aau-mobile .accordion-collapse');
const stickyLinks = document.querySelectorAll('.header-sticky-aau-mobile .nav-link');
Array.from(stickyLinks).forEach(element => {
    element.addEventListener('click', () => {
        const collapsedAauSticky = bootstrap_1.Collapse.getInstance(aauSticky);
        if (collapsedAauSticky) {
            collapsedAauSticky.hide();
        }
    });
});
let wiSticky = document.querySelector('.wealth-index-sticky .accordion-collapse');
const wiStickyLinks = document.querySelectorAll('.wealth-index-sticky .nav-item');
Array.from(wiStickyLinks).forEach(element => {
    element.addEventListener('click', (el) => {
        const wiStickyCollapse = bootstrap_1.Collapse.getOrCreateInstance(wiSticky);
        if (wiStickyCollapse) {
            wiStickyCollapse.hide();
        }
    });
});
// Stop HFA notification modal video from playing 
// when modal is closed by giving iframe random number
const iframe = document.getElementById('hfaIframe');
const rand = Math.floor((Math.random() * 1000000) + 1);
const hfaModal = document.getElementById('hfaNotificationModal');
if (hfaModal) {
    hfaModal.addEventListener('hide.bs.modal', function (event) {
        iframe.src = iframe.src + rand;
    });
}
// Stop BJ notification modal video from playing 
// when modal is closed by giving iframe random number
const bjIframe = document.getElementById('bjIframe');
const bjModal = document.getElementById('bjNotificationModal');
if (bjModal) {
    bjModal.addEventListener('hide.bs.modal', function (event) {
        bjIframe.src = bjIframe.src + rand;
    });
}
const swiper = new swiper_1.Swiper('.swiper', {
    speed: 500,
    spaceBetween: 100,
    autoplay: true,
    loop: true,
    modules: [swiper_1.Autoplay]
});
const swiperStats = new swiper_1.Swiper('.swiper-stats', {
    speed: 500,
    spaceBetween: 100,
    autoplay: true,
    loop: true,
    navigation: { nextEl: ".swiper-stats-next", prevEl: ".swiper-stats-prev" },
    modules: [swiper_1.Navigation, swiper_1.Autoplay]
});
const swiperHighlights = new swiper_1.Swiper('.swiper-highlights', {
    speed: 500,
    autoplay: true,
    loop: true,
    slidesPerView: 2,
    navigation: { nextEl: ".swiper-highlights-next", prevEl: ".swiper-highlights-prev" },
    modules: [swiper_1.Navigation, swiper_1.Autoplay]
});
const swiperHighlights2 = new swiper_1.Swiper('.swiper-highlights2', {
    speed: 500,
    autoplay: true,
    loop: true,
    slidesPerView: 2,
    navigation: { nextEl: ".swiper-highlights2-next", prevEl: ".swiper-highlights2-prev" },
    modules: [swiper_1.Navigation, swiper_1.Autoplay]
});
const swiperGallery = new swiper_1.Swiper('.swiper-gallery', {
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
    modules: [swiper_1.Pagination, swiper_1.Autoplay],
    autoplay: true
});
const swiperHighlight = new swiper_1.Swiper('.swiper-highlight', {
    loop: true,
    speed: 500,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
    modules: [swiper_1.Pagination, swiper_1.Autoplay, swiper_1.EffectFade],
    autoplay: true
});
const swiperCareerAwards = new swiper_1.Swiper('.swiper-careers-awards', {
    speed: 500,
    spaceBetween: 100,
    autoplay: false,
    autoHeight: false,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
    },
    modules: [swiper_1.Pagination, swiper_1.Autoplay],
});
const swiperQuotes = new swiper_1.Swiper('.swiper-quotes', {
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
    },
    modules: [swiper_1.Pagination]
});
const swiperAwards = new swiper_1.Swiper('.swiper-awards', {
    speed: 500,
    spaceBetween: 100,
    autoplay: true,
    autoHeight: true,
    loop: true,
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    modules: [swiper_1.Navigation, swiper_1.Autoplay],
});
//wealth index map mobile logic
const mapRegions = document.getElementsByClassName('regions');
Array.from(mapRegions).forEach((el, index) => {
    const regionId = el.getAttribute('id');
    const mapRegion = document.getElementById(regionId);
    mapRegion.addEventListener("change", function () { mapSelect(mapRegion); });
});
function mapSelect(region) {
    const id = region.value;
    const map = document.getElementById('map-' + region.id);
    const regions = map.querySelectorAll('.map-region');
    Array.from(regions).forEach((el, index) => {
        const element = el;
        if (element.id == id) {
            element.style.display = 'block';
            element.style.opacity = '1';
        }
        else {
            element.style.display = 'none';
            element.style.opacity = '0';
        }
    });
}
const tablePress = document.querySelectorAll('.tablepress');
Array.from(tablePress).forEach((el, index) => {
    //console.log(el,'el');
    const element = el;
    const elID = el.id;
    //check if performance panel table 
    if (el.id != 'tablepress-272') {
        //console.log(element.offsetWidth,'width');
        const wrapper = document.createElement('div');
        wrapper.classList.add('tablepress-scrollable');
        element.after(wrapper);
        wrapper.prepend(element);
    }
    else {
        el.classList.remove('tablepress');
        element.style.display = 'table';
    }
});
//sipp select logic
const sippSelectEl = document.getElementById("sipp-select");
if (sippSelectEl) {
    sippSelectEl.addEventListener("change", sippChange);
    const sippTables = document.getElementsByClassName('sipp-table');
    Array.from(sippTables).forEach((el, index) => {
        const name = el.getAttribute('data-name');
        // console.log(name,'table name');
        const id = 'sipp-table-' + index;
        el.setAttribute('id', id);
        sippSelectEl.options[sippSelectEl.options.length] = new Option(name, id);
    });
}
function sippChange() {
    //console.log('sipp change')
    const id = sippSelectEl.value;
    //console.log(id);
    const tables = document.getElementsByClassName('sipp-table');
    sippSelectEl.addEventListener("change", sippChange);
    Array.from(tables).forEach((el, index) => {
        const element = el;
        if (element.id == id) {
            element.style.display = 'block';
            element.style.opacity = '1';
            // const theadDiv = document.createElement('div');
            // theadDiv.classList.add('thead-sticky-wrapper');
            // const table = element.querySelector('table') as HTMLElement;
            const thead = element.querySelectorAll('thead');
            //thead.style.width = element.offsetWidth+'px';
            // Array.from(thead).forEach((el, index)=>{
            //     table.prepend(theadDiv);
            //     theadDiv.prepend(el);
            // })
        }
        else {
            element.style.display = 'none';
            element.style.opacity = '0';
        }
    });
}
//console.log('foo1');
//portfolio select logic
const portfolioSelectEl = document.getElementById("floatingSelectNew");
//console.log(portfolioSelectEl,'portfolioSelectEl');
if (portfolioSelectEl) {
    portfolioSelectEl.addEventListener("change", portfolioChange);
}
function portfolioChange(event) {
    //console.log(event.target.value,'value')
    const parent = event.target.closest('form');
    //console.log(parent,'parent')
    if (event.target.value == 'N/A') {
        //remove form-lead class
        parent.classList.remove('form-lead');
    }
    else {
        //add form-lead class
        parent.classList.remove('pb-4');
        parent.classList.add('form-lead', 'pb-4');
    }
}
function stickyHeight(stickyHeader) {
    const header = document.querySelectorAll('header');
    const main = document.querySelectorAll('main > .container-xl');
    let viewportHeight = window.innerHeight + 20;
    let stickyEl;
    const stickyNav = document.querySelector('nav.wi-landing-sticky');
    if (stickyNav) {
        stickyEl = stickyNav;
    }
    else {
        stickyEl = stickyHeader;
    }
    if (stickyEl) {
        const navSticky = document.querySelectorAll('nav.wealth-index-sticky');
        Array.from(navSticky).forEach((el, index) => {
            const remainHeight = header[0].clientHeight + stickyEl.clientHeight;
            let dif = main[0].clientHeight - remainHeight;
            const element = el;
            if (window.scrollY > 211 && window.scrollY < dif) {
                element.style.height = viewportHeight - remainHeight + 'px';
            }
            else {
                element.style.height = 'auto';
            }
        });
    }
}
//team profile
let cardToggle = document.querySelectorAll('.profile-more-toggle');
if (cardToggle.length > 0) {
    cardToggle[0].addEventListener('click', function (event) {
        event.preventDefault();
        const evtTarget = event.target;
        const target = evtTarget.dataset.target;
        const btn = evtTarget.dataset.btn;
        const elTarget = document.getElementsByClassName(target);
        const elBtn = document.getElementsByClassName(btn);
        elTarget[0].classList.toggle("active");
        elBtn[0].classList.toggle("active");
    });
}
let citations = document.querySelectorAll('.eat-citation');
//console.log(citations,'citations');
if (citations.length > 0) {
    let citationsInner = document.querySelectorAll('.citations-box .profile-more-inner');
    const list = document.createElement("ul");
    list.classList.add('mt-5', 'list-unstyled', 'citations-list');
    citationsInner[0].prepend(list);
    const schemaArray = [];
    Array.from(citations).forEach((el, index) => {
        el.addEventListener('click', (event) => {
            event.preventDefault();
        });
        const href = el.getAttribute('href');
        const text = el.innerHTML;
        const title = el.getAttribute('title');
        el.setAttribute('title', '');
        el.setAttribute('data-bs-toggle', 'tooltip');
        el.setAttribute('data-bs-trigger', "click");
        el.setAttribute('data-bs-placement', "bottom");
        const listItem = document.createElement("li");
        if (el.classList.contains('eat-nolink')) {
            el.setAttribute('data-bs-title', text + " " + title);
            listItem.innerHTML = '<li class="mb-3">' + text + ' ' + title + '</li>';
        }
        else {
            el.setAttribute('data-bs-title', text + " <a href='" + href + "' target='_blank'>" + title + "</a>");
            el.setAttribute('data-bs-html', "true");
            listItem.innerHTML = '<li class="mb-3">' + text + ' <a href="' + href + '" target="_blank" class="text-dust">' + title + '</a></li>';
        }
        list.appendChild(listItem);
        //push citation to schema
        //schemaArray.push(title);
    });
    // const saltusArticle0 = saltusArticle[0];
    // //get schema inner HTML
    // const saltusArticleObj = JSON.parse(saltusArticle0.innerHTML);
    // //add citations
    // saltusArticleObj.citations = schemaArray;
    // saltusArticle0.innerHTML = JSON.stringify(saltusArticleObj);
    let citationsBox = document.querySelectorAll('.citations-box');
    citationsBox[0].classList.remove('d-none');
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap_1.Tooltip(tooltipTriggerEl));
    //console.log(tooltipTriggerList,'trigger list');
}
//areas select mobile logic
const modalNavOpen = sessionStorage.getItem("modalNavOpen");
const menuAreasAll = document.querySelectorAll("#areas");
menuAreasAll.forEach(el => {
    const menuAreas = el;
    if (menuAreas) {
        menuAreas.addEventListener("change", () => areaSelect(menuAreas));
    }
});
if (modalNavOpen) {
    let modalNav;
    modalNav = bootstrap_1.Modal.getOrCreateInstance(document.querySelector('#mobile-nav'));
    modalNav.show();
    document.body.classList.add('modal-menu-open');
    activeModal = modalNav;
    let areas = document.querySelectorAll('.nav-area');
    let menuAreas = document.querySelector('#areas');
    Array.from(areas).forEach((el, index) => {
        const element = el;
        if (element.id == menuAreas.value) {
            element.style.display = 'block';
            element.style.opacity = '1';
        }
        else {
            element.style.display = 'none';
            element.style.opacity = '0';
        }
        if (index == (areas.length - 1)) {
            sessionStorage.removeItem("modalNavOpen");
        }
    });
}
function areaSelect(menuAreas) {
    const id = menuAreas.value;
    //console.log(id, 'id area select');
    const active_top = document.getElementById('mobile-nav').getAttribute('data-active-top');
    const url = menuAreas.options[menuAreas.selectedIndex].getAttribute('data-page');
    const text = menuAreas.options[menuAreas.selectedIndex].text;
    if (url && active_top != text) {
        window.location.assign(url);
        //window.history.pushState({}, '', url);
        sessionStorage.setItem("modalNavOpen", 'true');
    }
    let areas = document.querySelectorAll('.nav-area');
    Array.from(areas).forEach((el, index) => {
        const element = el;
        if (element.id == id) {
            element.style.display = 'block';
            element.style.opacity = '1';
        }
        else {
            element.style.display = 'none';
            element.style.opacity = '0';
        }
    });
}
// fa modal
let faModals = document.querySelectorAll('#faModal');
Array.from(faModals).forEach(el => {
    bootstrap_1.Modal.getOrCreateInstance(el).show();
});
let faButtons = document.querySelectorAll('#faModal button');
Array.from(faButtons).forEach(el => {
    el.addEventListener('click', function (event) {
        //console.log('event', event)
        const target = event.target;
        if (target.id == 'fa-yes') {
            //set the cookie
            document.cookie = "advisersModalAccepted=true;path=/";
            //close the modal
            Array.from(faModals).forEach(el => {
                bootstrap_1.Modal.getOrCreateInstance(el).hide();
            });
        }
        else {
            //redirect to home
            window.location.href = "/";
        }
    });
});
//video CTA 
let blogVideoImages = document.getElementsByClassName('blog-video-image');
Array.from(blogVideoImages).forEach(el => {
    let element = el;
    let video = element.previousSibling.previousSibling;
    let src = video.src;
    el.addEventListener('click', function (event) {
        //console.log(src);
        video.style.opacity = '1';
        video.style.zIndex = '1';
        video.src = src + '&autoplay=1&mute=1';
        element.style.opacity = '0';
        element.style.zIndex = '0';
    });
});
//check FA loaded
// let span = document.createElement('span');
// let ctaIcons = document.getElementsByClassName('cta-icon')
//     span.classList.add('fa-test','fa-kit','fa-saltuscta-1');
//     span.style.display = 'none';
//     document.body.insertBefore(span, document.body.firstChild);
//     function css(element:any, property:any) {
//       return window.getComputedStyle(element, null).getPropertyValue(property);
//     }
//     setTimeout(function() {
//         let fontFamily = css(span, 'font-family')
//         if (fontFamily === '"Font Awesome Kit"') {
//             Array.from(ctaIcons).forEach(el=>{
//                 let element = el as HTMLElement
//                 element.classList.add('fa-loaded');
//             });
//           }
//           document.body.removeChild(span);
//     },250);
// CTA id of index 
let ctaButtons = document.querySelectorAll('a.cta-btn:not(#header-contact):not(#header-contact-mobile):not(#new_contact):not(#existing_contact), .cta_btn:not(#header-contact):not(#header-contact-mobile):not(#new_contact):not(#existing_contact)');
Array.from(ctaButtons).forEach((el, index) => {
    //console.log(el, 'el');
    // console.log(index, 'el index');
    el.setAttribute('id', 'cta-' + (index + 1));
});
//block home intro link when search bar in use - no longer in use?
const homeIntro = document.getElementById("homepage-intro");
if (homeIntro) {
    const s = document.getElementById("s");
    const focusInHandler = function (e) {
        //console.group('in');
        homeIntro.style.pointerEvents = 'none';
    };
    const focusOutHandler = function (e) {
        // console.group('out');
        homeIntro.style.pointerEvents = 'auto';
    };
    s.addEventListener('focusin', focusInHandler);
    s.addEventListener('focusout', focusOutHandler);
}
/* new styles scripts */
const alpinejs_1 = __importDefault(require("alpinejs"));
const collapse_1 = __importDefault(require("@alpinejs/collapse"));
require("@tailwindplus/elements");
const modalVideoButtons = document.querySelectorAll('.modal_video_btn');
modalVideoButtons.forEach(btn => {
    btn.addEventListener('click', () => {
        const targetId = btn.getAttribute('commandfor');
        const videoModal = document.getElementById(targetId);
        const video = videoModal.querySelector('.lite-vimeo');
        video.addIframe();
    });
});
const modals = document.querySelectorAll('dialog[id^="modal-"]');
modals.forEach(modal => {
    modal.addEventListener('click', (e) => {
        const target = e.target;
        const isDialog = target === modal;
        const isTabbable = target.tagName === 'DIV' && target.hasAttribute('tabindex');
        if (isDialog || isTabbable) {
            const liteVimeo = modal.querySelector('.lite-vimeo');
            if (liteVimeo) {
                liteVimeo.innerHTML = '';
                liteVimeo.classList.remove('ltv-activated');
            }
        }
    });
});
document.addEventListener('DOMContentLoaded', () => {
    alpinejs_1.default.plugin(collapse_1.default);
    alpinejs_1.default.start();
});
const swiperStatsNew = new swiper_1.Swiper(".swiper-stats-new", {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    speed: 500,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    observer: true,
    observeParents: true,
    navigation: {
        enabled: false
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: false
    },
    autoplay: true,
    modules: [swiper_1.Navigation, swiper_1.EffectFade, swiper_1.Autoplay, swiper_1.Pagination]
});
const swiperReviews = new swiper_1.Swiper(".swiper-reviews", {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 32,
    loop: false,
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    observer: true,
    observeParents: true,
    navigation: {
        disabledClass: "arrow_btn_disabled",
        nextEl: ".reviews-next",
        prevEl: ".reviews-prev",
    },
    breakpoints: {
        576: {
            slidesPerView: 2,
            slidesPerGroup: 2,
        },
        900: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
        1600: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 64
        },
    },
    modules: [swiper_1.Navigation, swiper_1.EffectFade]
});
const swiperVideos = new swiper_1.Swiper(".swiper-videos", {
    slidesPerView: 2.5,
    slidesPerGroup: 1,
    spaceBetween: 16,
    slidesOffsetAfter: 16,
    loop: false,
    watchOverflow: true,
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    observer: true,
    observeParents: true,
    navigation: {
        disabledClass: "arrow_btn_disabled",
        nextEl: ".video-next",
        prevEl: ".video-prev",
    },
    breakpoints: {
        0: {
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            spaceBetween: 16,
            slidesOffsetAfter: 16,
        },
        1155: {
            slidesPerView: 2.5,
            slidesPerGroup: 1,
            spaceBetween: 16,
            slidesOffsetAfter: 16,
        },
        1600: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 16,
            slidesOffsetAfter: 0,
        },
    },
    modules: [swiper_1.Navigation]
});
ScrollReveal().reveal('.block-reveal-video', {
    interval: 750,
    delay: 0,
    viewFactor: 0,
    opacity: 1,
    distance: '0px',
    duration: 0,
    reset: false,
    afterReveal: onRevealNew,
});
ScrollReveal().reveal('.block-reveal-ticker', {
    interval: 750,
    delay: 0,
    viewFactor: 0.25,
    opacity: 1,
    distance: '0px',
    duration: 0,
    reset: false,
    afterReveal: onRevealNew,
});
function onRevealNew(el) {
    //console.log(el,'el reveal')
    el.classList.add('is-visible');
    if (el.classList.contains("block-reveal-video")) {
        const video = document.querySelector('.block-reveal-video .lite-vimeo');
        video.addIframe();
        const iframe = document.querySelector('.block-reveal-video .lite-vimeo iframe');
        iframe.src = iframe.src + '&background=1&loop=0';
    }
    if (el.classList.contains("block-reveal-ticker")) {
        start();
    }
}
ScrollReveal().reveal('.step', {
    distance: '60px',
    origin: 'bottom',
    opacity: 0,
    duration: 750,
    interval: 250,
    easing: 'ease-out',
    reset: false // only once, no repeat on scroll back
});
const performancePanel = document.getElementById('performance_panel');
let values = [0, 0, 0];
const speed = 500000; // fixed speed
let startTime = null;
let rafId = null;
let targets;
let diffTarget;
let numA;
let numB;
let numDiff;
let diff;
let barA;
let barB;
let pctA;
let pctB;
if (performancePanel) {
    const totalsString = performancePanel.dataset.totals;
    targets = totalsString.split(',').map(s => Number(s.trim()));
    diffTarget = targets[1] - targets[0];
    numA = document.getElementById('numA');
    numB = document.getElementById('numB');
    numDiff = document.getElementById('numDiff');
    diff = document.getElementById('diff');
    barA = document.getElementById('barA');
    barB = document.getElementById('barB');
    pctA = document.getElementById('pctA');
    pctB = document.getElementById('pctB');
}
function format(n) { return n.toLocaleString(); }
function step(ts) {
    if (startTime === null)
        startTime = ts;
    const elapsed = (ts - startTime) / 1000;
    const distance = speed * elapsed;
    const valA = Math.min(Math.round(distance), targets[0]);
    const valB = Math.min(Math.round(distance), targets[1]);
    const valDiff = Math.min(Math.max(valB - valA, 0), diffTarget);
    values = [valA, valB, valDiff];
    numA.textContent = format(valA);
    numB.textContent = format(valB);
    numDiff.textContent = format(valDiff);
    const pct1 = Math.round(valA / targets[0] * 100);
    const pct2 = Math.round(valB / targets[1] * 100);
    barA.style.width = pct1 + '%';
    barB.style.width = pct2 + '%';
    // Show percentage labels after both tickers finish
    if (valA >= targets[0] && valB >= targets[1]) {
        pctA.classList.add('et:opacity-100');
        pctB.classList.add('et:opacity-100');
        pctA.classList.remove('et:opacity-0');
        pctB.classList.remove('et:opacity-0');
    }
    // Fade in difference when it starts (>0)
    if (valDiff > 0) {
        diff.classList.add('et:opacity-100');
        diff.classList.remove('et:opacity-0');
    }
    const done = valA >= targets[0] && valB >= targets[1] && valDiff >= diffTarget;
    if (!done) {
        rafId = requestAnimationFrame(step);
    }
    else {
        rafId = null;
    }
}
function resetUI() {
    numA.textContent = '0';
    numB.textContent = '0';
    numDiff.textContent = '0';
    barA.style.width = '0%';
    barB.style.width = '0%';
    pctA.classList.remove('et:opacity-100');
    pctB.classList.remove('et:opacity-100');
    pctA.classList.add('et:opacity-0');
    pctB.classList.add('et:opacity-0');
    diff.classList.remove('et:opacity-100');
    diff.classList.add('et:opacity-0');
}
function start() {
    if (rafId)
        cancelAnimationFrame(rafId);
    startTime = null;
    values = [0, 0, 0];
    resetUI();
    rafId = requestAnimationFrame(step);
}
/* mantelpiece */
const marqueeWrapper = document.getElementById('marquee-wrapper');
if (marqueeWrapper) {
    const marqueeGroup = marqueeWrapper.querySelector('.marquee-group');
    const startImage = marqueeWrapper.querySelector('.marquee-start');
    // ---- Specials ----
    const insertElements = [
        '<div class="special" style="position:relative;"><img src="https://saltus.co.uk/wp-content/themes/Saltus/src/images/FireplaceDog_Animation.gif" width="525" class="et:opacity-100 et:left-[-200px] et:top-[117px]" alt="dog" loading="lazy"></div>',
        '<div class="special" style="position:relative;"><img src="https://saltus.co.uk/wp-content/themes/Saltus/src/images/Trophy 2@2x.webp" width="65" class="et:opacity-100 et:top-[121px]" alt="trophy 1" loading="lazy"></div>',
        '<div class="special" style="position:relative;"><img src="https://saltus.co.uk/wp-content/themes/Saltus/src/images/FireplaceCat_Animation.gif" width="400" class="et:opacity-100 et:left-[-100px] et:top-[80px]" alt="cat" loading="lazy"></div>',
        '<div class="special" style="position:relative;"><img src="https://saltus.co.uk/wp-content/themes/Saltus/src/images/Trophy 1@2x.webp" width="65" class="et:opacity-100 et:top-[114px]" alt="trophy 2" loading="lazy"></div>'
    ];
    function insertSpecialsInto(group) {
        const frameContainers = Array.from(group.querySelectorAll('.marquee-frame-container'));
        let insertIndex = 0;
        for (let i = 2; i < frameContainers.length; i += 3) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = insertElements[insertIndex % insertElements.length];
            const frameContainer = frameContainers[i];
            frameContainer.after(tempDiv.firstChild);
            insertIndex++;
        }
    }
    // Insert specials
    insertSpecialsInto(marqueeGroup);
    // Clone awards group for seamless scrolling
    const clone = marqueeGroup.cloneNode(true);
    marqueeWrapper.appendChild(clone);
    // ---- Responsive scrolling ----
    let scrollX = 0;
    let lastTime = performance.now();
    let groupWidth = marqueeGroup.offsetWidth;
    // Track container width to avoid recalculating on URL-bar resize
    let lastContainerWidth = document.getElementById('marquee-container').offsetWidth;
    // ---- Flags ----
    let pausedByClick = false;
    let pausedByViewport = false;
    let pausedByOrientation = false;
    function setInitialScroll() {
        const container = document.getElementById('marquee-container');
        const containerWidth = container.offsetWidth;
        // measure the h2
        const heading = document.getElementById('marquee-heading');
        const headingWidth = heading ? heading.offsetWidth : 0;
        // anchor start so marquee content begins where h2 ends
        scrollX = headingWidth;
        // optional: if heading wider than container, anchor left
        if (scrollX > containerWidth) {
            scrollX = 0;
        }
    }
    function handleResize() {
        const container = document.getElementById('marquee-container');
        const containerWidth = container.offsetWidth;
        if (containerWidth !== lastContainerWidth) {
            groupWidth = marqueeGroup.offsetWidth;
            setInitialScroll();
            lastContainerWidth = containerWidth;
        }
    }
    // --- Debounce wrapper ---
    let resizeTimeout;
    function debouncedResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 150);
    }
    // Listeners
    window.addEventListener('resize', debouncedResize);
    window.addEventListener('orientationchange', () => {
        pausedByOrientation = true;
        setTimeout(() => {
            handleResize();
            pausedByOrientation = false;
            lastTime = performance.now(); // reset animation timer
        }, 75);
    });
    // Initial setup
    setInitialScroll();
    // --- CLICK HANDLING ---
    const marqueeContainer = document.getElementById('marquee-container');
    marqueeContainer.addEventListener('click', () => {
        pausedByClick = true;
        marqueeContainer.classList.add("clicked");
        setTimeout(() => {
            pausedByClick = false;
            lastTime = performance.now(); // reset timer so animation stays smooth
            marqueeContainer.classList.remove("clicked");
        }, 3000); // pause for 3 seconds
    });
    // ---- ANIMATION ----
    const scrollSpeed = 1.25;
    let bufferTop, bufferBottom;
    function updateBuffers() {
        bufferTop = window.innerWidth < 1155 ? 90 : 160;
        bufferBottom = bufferTop;
    }
    updateBuffers();
    window.addEventListener('resize', updateBuffers);
    function isElementInViewportWithBuffers(el, bufferTop, bufferBottom) {
        const rect = el.getBoundingClientRect();
        const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        return rect.bottom > bufferBottom && rect.top < viewportHeight + bufferTop;
    }
    function animateMarquee(time) {
        pausedByViewport = !isElementInViewportWithBuffers(document.getElementById('marquee-container'), bufferTop, bufferBottom);
        const paused = pausedByClick || pausedByViewport || pausedByOrientation;
        if (!paused) {
            const delta = time - lastTime;
            scrollX -= scrollSpeed * (delta / 16);
            if (scrollX <= -(groupWidth + startImage.offsetWidth)) {
                scrollX += groupWidth;
            }
            marqueeWrapper.style.transform = `translateX(${scrollX}px)`;
        }
        lastTime = time;
        requestAnimationFrame(animateMarquee);
    }
    requestAnimationFrame(animateMarquee);
}
/* performance scroll */
const containerX = document.getElementById('scroll-container-x');
if (containerX) {
    const thumbX = document.getElementById('scroll-thumb-x');
    function updateThumbX() {
        const scrollWidth = containerX.scrollWidth;
        const clientWidth = containerX.clientWidth;
        // Hide thumb if content fits
        if (scrollWidth <= clientWidth) {
            thumbX.style.display = 'none';
            return;
        }
        else {
            thumbX.style.display = 'block';
        }
        const scrollLeft = containerX.scrollLeft;
        const thumbWidth = Math.max((clientWidth / scrollWidth) * clientWidth, 20);
        const thumbLeft = (scrollLeft / scrollWidth) * clientWidth;
        thumbX.style.width = thumbWidth + 'px';
        thumbX.style.left = thumbLeft + 'px';
    }
    // Initial check
    updateThumbX();
    // Update on scroll & resize
    containerX.addEventListener('scroll', updateThumbX);
    window.addEventListener('resize', updateThumbX);
}
const et_main = document.getElementById("et_main");
if (et_main) {
    const et_first = et_main.firstElementChild;
    const et_float = document.getElementById("et_floating_contact");
    if (et_first && et_float) {
        window.addEventListener('scroll', () => {
            const rect = et_first.getBoundingClientRect();
            // Check if elementA is fully scrolled past (bottom above viewport top)
            if (rect.bottom < 0) {
                et_float.classList.add('active');
            }
            else {
                et_float.classList.remove('active');
            }
        });
    }
    // if (et_first && et_float) {
    //   const observer = new IntersectionObserver(
    //     (entries) => {
    //       entries.forEach((entry) => {
    //         if (!entry.isIntersecting) {
    //           et_float.classList.remove("active");
    //         } else {
    //           et_float.classList.add("active");
    //         }
    //       });
    //     },
    //     {
    //         threshold: 0,
    //            rootMargin: "0px 0px -100% 0px", 
    //     }
    //   );
    //   observer.observe(et_first);
    // }
}
// header_lower sticky logic
if (window.innerWidth > 1155) {
    const header_lower = document.getElementById("header_lower");
    const body = document.querySelector("body");
    const shrinkThreshold = header_lower.offsetTop;
    // Create a spacer div
    const spacer = document.createElement("div");
    spacer.style.width = "100%";
    spacer.style.display = "none"; // hidden initially
    // Insert spacer before header
    header_lower.parentElement.insertBefore(spacer, header_lower);
    window.addEventListener("scroll", () => {
        if (window.scrollY >= shrinkThreshold) {
            header_lower.classList.add("shrinked");
            body.classList.add("body_header_shrinked");
            // Set spacer height to current header_lower height
            spacer.style.height = `${header_lower.offsetHeight}px`;
            spacer.style.display = "block";
        }
        else {
            header_lower.classList.remove("shrinked");
            body.classList.remove("body_header_shrinked");
            spacer.style.display = "none";
        }
    });
}
// Set previous_url and page_url hidden fields
const previousUrlFields = document.querySelectorAll('input[name="previous_url"]');
if (previousUrlFields.length) {
    const ref = document.referrer;
    if (ref && ref.indexOf(window.location.href) === -1) {
        sessionStorage.setItem('saltus_previous_url', ref);
    }
    const previousUrl = sessionStorage.getItem('saltus_previous_url') || '';
    const pageUrl = previousUrl || window.location.href;
    previousUrlFields.forEach(el => { el.value = previousUrl; });
    document.querySelectorAll('input[name="page_url"]').forEach(el => { el.value = pageUrl; });
}
/* new styles scripts end */ 
